import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container", "card", "dot"];
  static values = { showNavigation: Boolean };

  connect() {
    this.currentIndex = 0;
    this.observeScroll();
  }

  observeScroll() {
    if (!this.hasContainerTarget) return;

    const options = {
      root: this.containerTarget,
      threshold: 0.5,
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = parseInt(entry.target.dataset.index, 10);
          this.updateActiveDot(index);
        }
      });
    }, options);

    this.cardTargets.forEach((card) => {
      this.observer.observe(card);
    });
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  goToCard(event) {
    const index = parseInt(event.currentTarget.dataset.index, 10);
    this.scrollToCard(index);
  }

  scrollToCard(index) {
    const card = this.cardTargets[index];
    if (!card || !this.hasContainerTarget) return;

    const container = this.containerTarget;
    const containerWidth = container.offsetWidth;
    const cardWidth = card.offsetWidth;
    const cardOffsetLeft = card.offsetLeft;
    const scrollPosition = cardOffsetLeft - containerWidth / 2 + cardWidth / 2;

    container.scrollTo({
      left: Math.max(0, scrollPosition),
      behavior: "smooth",
    });

    this.updateActiveDot(index);
  }

  updateActiveDot(index) {
    if (!this.showNavigationValue) return;

    this.currentIndex = index;

    this.dotTargets.forEach((dot, i) => {
      if (i === index) {
        dot.classList.remove("bg-white");
        dot.classList.add("bg-primary");
      } else {
        dot.classList.remove("bg-primary");
        dot.classList.add("bg-white");
      }
    });
  }

  previous() {
    if (this.currentIndex > 0) {
      this.scrollToCard(this.currentIndex - 1);
    }
  }

  next() {
    if (this.currentIndex < this.cardTargets.length - 1) {
      this.scrollToCard(this.currentIndex + 1);
    }
  }
}
